import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormGroup from '@material-ui/core/FormGroup';
import Box from '@material-ui/core/Box';

import TodoItem from './TodoItem'

import Store from 'store';

class TodoList extends Component {
  newTodoName = ""
  groupKey = ""

  state = {
    todoItems : []
  };

  groupKey = () => {
    return "todos_" + this.group
  }

  constructor(props) {
    super(props);

    this.groupKey = "todos_" + props.group;

    var todos = Store.get(this.groupKey);
    if (todos === undefined) {
      Store.set(this.groupKey, [])
      todos = []
    }

    this.state = {
      todoItems : todos
    }
  }

  handleCreate = () => {

    if (this.newTodoName === "") {
      return;
    }

    var newTodoItems = this.state.todoItems;
    newTodoItems.push({ name:this.newTodoName, done:false});

    Store.set(this.groupKey,newTodoItems);
    this.setState({
      todoItems : newTodoItems,
      newTodoName : ""
    });
  };

  handleChange = (event) => {
    const input = event.target;
    const value = input.value;
    this.newTodoName = value;
  };

  render() {

    var todoListItems = [];
    for (var i = 0; i < this.state.todoItems.length; i++) {
      var item = this.state.todoItems[i];
      todoListItems.push(<TodoItem item={item} key={item.name}/>);
    }

    return (
      <Box p={3}>

        <FormGroup>

        </FormGroup>
        <Grid container spacing={1}>
          <Grid item xs>
            <TextField
              fullWidth
              label="Todo Item"
              value={this.state.newTodoName}
              onChange={this.handleChange}/>
          </Grid>
          <Grid item xs={1}>
            <Button variant="contained" color="primary" type="submit" onClick={this.handleCreate}>Create</Button>
          </Grid>
        </Grid>

        <Box pt={3}>
          <Grid>
            {todoListItems}
          </Grid>
        </Box>
      </Box>
    )
  }
}

export default TodoList;



// WEBPACK FOOTER //
// ./src/comps/TodoList.js